var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPharmacy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-00-MyClients-editAction",
    transform: "translate(-219.000000, -592.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-pharmacyInfo",
    transform: "translate(220.000000, 593.000000)",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 C0,3.58186667 3.58186667,0 8,0 C12.4181333,0 16,3.58186667 16,8 C16,12.4181333 12.4181333,16 8,16 C3.58186667,16 0,12.4181333 0,8 L0,8 Z",
    id: "Stroke-3095",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3112",
    strokeWidth: 0.8,
    points: "12.2666667 6.4 9.6 6.4 9.6 3.73333333 6.4 3.73333333 6.4 6.4 3.73333333 6.4 3.73333333 9.6 6.4 9.6 6.4 12.2666667 9.6 12.2666667 9.6 9.6 12.2666667 9.6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPharmacy);
export default __webpack_public_path__ + "static/media/icPharmacy.2a275e1dc0e98c162acb28127fc029db.svg";
export { ForwardRef as ReactComponent };